import Vue from 'vue'
import Router from 'vue-router'
import Text from './components/Text'
import Goals from './components/Goals'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Text,
      props: {text_id: 1}
    },
    {
      path: '/search',
      name: 'search',
      component: Goals,
    },
    {
      path: '/wat-je-moet-weten',
      name: 'wat-je-moet-weten',
      component: Text,
      props: {text_id: 2}
    },
    {
      path: '/verantwoording',
      name: 'verantwoording',
      component: Text,
      props: {text_id: 5}
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: Text,
      props: {text_id: 3}
    },
    {
      path: '/over-cedin',
      name: 'over-cedin',
      component: Text,
      props: {text_id: 4}
    },
  ]
})
